import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AnimatePresence, LazyMotion, domAnimation } from 'framer-motion';
import { ThemeProvider } from './context/ThemeContext';

// Context
import { AuthProvider } from './context/AuthContext';

// Router
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import TransitionLoader from './components/common/TransitionLoader';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app-container">
          <ThemeProvider>
            <ToastContainer position="bottom-center" autoClose={4000} rtl={true} />

            <LazyMotion features={domAnimation}>
              <AnimatePresence mode="wait">
                <Suspense fallback={<TransitionLoader />}>
                  <AppRoutes />
                </Suspense>
              </AnimatePresence>
            </LazyMotion>
          </ThemeProvider>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;